module.exports = __webpack_public_path__ + "img/back01.3d6cd708.jpg";